import React, { useRef, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateVideo } from "../../../../../api/inquiries/video/use-video";
import { useVideoById } from "../../../../../api/inquiries/video/use-video-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import Editor from "../../../../../components/Editor";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";

const VideoEditPage = () => {
  const quillRef = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useVideoById(id);
  const videoData = data?.data;
  const [title, setTitle] = React.useState(videoData?.title);
  const [videoUrl, setVideoUrl] = React.useState(videoData?.url);
  const [submittedUrl, setSubmittedUrl] = React.useState(videoData?.url);
  const [isSaved, setIsSaved] = React.useState(false);
  const videoId = videoUrl?.includes("watch")
    ? videoUrl?.split("watch?v=")[1]
    : videoUrl?.includes("youtu.be")
    ? videoUrl?.split("youtu.be/")[1]
    : "";
  const { mutate: updateVideo } = useUpdateVideo();
  const [isContentsEmpty, setIsContentsEmpty] = useState(false);

  const formEmpty = useMemo(
    () =>
      videoUrl === "" || submittedUrl === "" || title === "" || isContentsEmpty,
    [videoUrl, submittedUrl, title, isContentsEmpty]
  );

  const onTextChange = (content) => {
    setIsContentsEmpty(quillRef?.current?.getLength() === 1);
  };
  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };
  const onChangeVideoUrl = (e) => {
    setVideoUrl(e.target.value);
  };
  const handleSubmit = async () => {
    const payload = {
      title: title,
      url: submittedUrl,
      contents: JSON.stringify(quillRef?.current?.getContents()),
      id: id,
    };
    await updateVideo(payload);
  };

  const handleBack = () => {
    navigate(`/bulletin-board/video/${id}`);
  };

  const onSetUrl = () => {
    setSubmittedUrl(videoUrl);
    setIsSaved(true);
  };

  return (
    <>
      <div>
        <TitlePage title="동영상 > 동영상 상세 > 동영상 수정" />
        <div className="mt-4">
          <form>
            <FieldBox label="동영상 링크">
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  placeholder="등록할 영상의 링크를 입력 후, 저장하기 눌러주세요."
                  className={`border border-border-grey flex-none h-8 w-[25rem] py-0.5 px-2 outline-none rounded-[4px]`}
                  value={videoUrl}
                  onChange={onChangeVideoUrl}
                  disabled={isSaved}
                />
                <Button
                  onClick={onSetUrl}
                  margin="m-0"
                  width="w-24"
                  text="저장하기"
                />
                <Modal
                  hasCancel={false}
                  hasSubmit={false}
                  hasClose={true}
                  title="영상 미리보기"
                  maxWidth="max-w-[45rem]"
                  description={
                    <div className="flex justify-center">
                      <iframe
                        title="intro_video"
                        width="650"
                        height="353"
                        src={`https://www.youtube.com/embed/${videoId}`}
                      ></iframe>
                    </div>
                  }
                >
                  <Button
                    margin="m-0"
                    width="w-24"
                    primary
                    text="영상 미리보기"
                    isDisabled={videoUrl === ""}
                  />
                </Modal>
              </div>
            </FieldBox>
            <FieldBox label="제목">
              <input
                className="rounded-[4px] w-full text-[12px] p-2 focus:outline-none"
                placeholder="제목을 입력해주세요"
                name="title"
                value={title}
                onChange={onChangeTitle}
              />
            </FieldBox>
            <FieldBox
              isLast
              label="내용"
              alignItems="items-start pt-6"
              padding="p-0"
            >
              <Editor
                ref={quillRef}
                defaultValue={JSON.parse(videoData?.contents)}
                onTextChange={onTextChange}
              />
            </FieldBox>
            <div className="flex justify-end mt-4">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleBack}
              >
                <Button width="w-24" text="입력취소" />
              </Modal>
              <Modal
                description="수정한 정보로 저장하시겠습니까?"
                onSubmit={handleSubmit}
              >
                <Button
                  width="w-24"
                  onClick={(e) => e.preventDefault()}
                  type="submit"
                  primary
                  text="등록완료"
                  isDisabled={formEmpty}
                />
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default VideoEditPage;
